if (!customElements.get('eot-product-information')) {
  customElements.define('eot-product-information', class extends HTMLElement {
    connectedCallback() {
      this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({data}) => {
        const main = document.querySelector('product-info[data-section]');
        if (main && data.sectionId !== main.dataset.section) return;
        const sku = data.variant?.sku || '';
        this.querySelector('[data-sku]').textContent = sku;
        this.querySelector('[data-sku-row]').hidden = !sku;
      });
    }
    disconnectedCallback() { this.unsubscribe?.(); }
  });
}
